import React, { useState, useEffect, useContext } from 'react';
import './TopBarDepartment.scss';
import { Dropdown, Space, Menu } from 'antd';

import { UserOutlined, LogoutOutlined } from '@ant-design/icons'; // Import Ant Design icons
import myImage from '../../assests/dummy.png'
import { Link } from "react-router-dom";
import image from '../../assests/logo.svg'
import { useNavigate } from 'react-router-dom';
import { UserInfo } from "../../Context/userInfo";


import { getRole } from '../../Helpers/utils'
const TopBar = ({ toggleSidebar ,logout}) => {

  const { userData, updateUserData } = useContext(UserInfo);
  const [roles, setRoles] = useState(null)

  const navigate = useNavigate();
  useEffect(() => {
    console.log(userData)
    if (userData) {
      setRoles(getRole(userData.data?.userInfo?.roles))
    }


  }, [userData])






  const items = [
    {
      label: (
        <Space>
          <UserOutlined />
          <span>My-Account</span>
        </Space>
      ),
      key: 'account',

    },
    {
      type: 'divider',
    },
    {
      label: (
        <Space>
          <LogoutOutlined />
          <span>Logout</span>
        </Space>
      ),
      key: 'logout',
      onClick: () => logout(),

    },
  ];


  const capitalizeFirstLetter = (str) => {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1);
  };


  return (
    <div
      className="home-section-department"
      style={{
        position: 'sticky',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: '10%',
      }}
    >
      {/* Menu Icon */}
      <div className="home-content">
        <i className="bx bx-menu" onClick={toggleSidebar} style={{ color: '#000' }}></i>
        <label className="fs-4 mt-1">{capitalizeFirstLetter(userData.data.userInfo.username)}</label>
        <i className="bx bx-bell ms-3" style={{ fontSize: '24px', color: '#000', cursor: 'pointer' }}></i>
        <i className="bx bx-phone ms-3" style={{ fontSize: '24px', color: '#000', cursor: 'pointer' }}></i>
      </div>

      {/* Logo or title */}
      <div
        className="logo-details"
        style={{
          fontFamily: 'Myriad Pro',
          fontSize: 'xx-large',
          color: '#000',
        }}
      ></div>

      {/* Right section */}
      <div
        className="profile-section"
        style={{
          display: 'flex',
          alignItems: 'center',
          marginRight: '2%',
          gap: '25px', // Adjust spacing here
        }}
      >
        {/* Icons group */}
        <div style={{ display: 'flex', gap: '20px' }}>
          {/* <button class="btn btn-outline-warning">Import</button>
          <button class="btn btn-warning text-white">Create ticket</button> */}
        </div>

        {/* Role */}
        <div className="mt-2" style={{ color: '#000' }}>
          <h5>
            <button
              type="button"
              className="btn"
              style={{ backgroundColor: '#4a90e2', color: 'white' }} // soft blue
            >
              Actions
            </button>
            <button
              type="button"
              className="btn ms-3"
              style={{ backgroundColor: '#2ecc71', color: 'white' }} // green
            >
              Import
            </button>
            <button
              type="button"
              className="btn ms-3"
              style={{ backgroundColor: '#e74c3c', color: 'white' }} // richer red
            >
              Create ticket
            </button>
          </h5>
        </div>


        {/* Profile dropdown */}
        <div>
          <Dropdown overlay={<Menu items={items} />} trigger={['click']}>
            <div onClick={(e) => e.preventDefault()}>
              <Space>
                <img
                  className="profile-img-department"
                  src={myImage}
                  alt="Logo"
                  style={{ width: '40px', height: '40px', borderRadius: '50%' }}
                />
              </Space>
            </div>
          </Dropdown>
        </div>
      </div>
    </div>


  );
};

export default TopBar;

